<template>
    <div class="main" :class="[isPhone && 'wap-main' , !isPhone && !isHome && 'homeBg', isSubject && 'subject', isSpecial == 0 && 'isNotSpecial', isSpecial == 1 && 'isSpecial']">
      <div class="pc-wrapper" v-if="!isPhone">
        <Header v-show="!isSubject || (isSubject && isSpecial == 0)"/>
        <div class="pc-container">
            <router-view v-show="!loadingShow" />
            <Loading v-show="loadingShow" />
            <BackTop />
            <Footer v-show="!loadingShow && (!isSubject || (isSubject && isSpecial == 0))" />
            <PopUp v-if="showPop" />
        </div>
      </div>
      <div class="wap-wrapper" v-if="isPhone">
          <Header v-show="!isSubject || (isSubject && isSpecial == 1)"/>
          <router-view v-show="!loadingShow" />
          <Loading v-show="loadingShow" />
          <Footer v-show="!loadingShow && (!isSubject || (isSubject && isSpecial == 0))" />
      </div>
    </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import BackTop from '@/components/BackTop'
import PopUp from '@/components/PopUp'
import Loading from '@/components/Loading'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      isHome: true,
    }
  },
  components: {
    Header,
    Footer,
    BackTop,
    PopUp,
    Loading
  },
  beforeCreate() {
    this.$axios.post(
        this.$ApiInfo.getColumnList
    ).then(data => {
        data.closeColumnList && this.setCloseColumnList(data.closeColumnList)
        data.indexChannel && (this.setIndexChannel(data.indexChannel));
        data.columnList && data.columnList.length && (this.setColumnList(data.columnList));
    })
  },
  created() {
    document.title = "四川互联网举报辟谣平台";
  },
  watch: {
    $route (val, oldVal) {
      if (val.path == '/') {
        this.isHome = true
      } else {
        this.isHome = false
      }
      if(val.path != oldVal.path) {
        this.setLoadingShow(true);
        this.setIsSubject(false);
        this.setIsSpecial(-1);
      }
    },
  },
  mounted() {
    if(this.isPhone) {
      document.body && (document.body.style.background = 'none')
    }
  },
  methods: {
    ...mapMutations(['setIndexChannel', 'setColumnList', 'setLoadingShow','setIsSubject','setIsSpecial','setCloseColumnList'])
  },
  computed: {
    ...mapState(['showPop', 'loadingShow','isSubject','isSpecial']),
    isPhone() {
      return this.$Common.Attribute.isMb()
    }
  }
}
</script>

<style lang='less'>
// html {
//   -webkit-filter: grayscale(1);
//   filter: grayscale(1);
// }
.main {
  .pc-wrapper {
    .pc-container {
      width: 64rem;
      margin: 0 auto;
    }
  }
}
.homeBg {
  background: linear-gradient(360deg, rgba(0, 109, 241, 0) 0%, rgba(0, 109, 241, 0.87) 79%, #006DF1 100%);
  background-size: 100% 37.75rem;
  background-repeat: no-repeat;
  &.channelBg {
    background: linear-gradient(#89e6ff,#89e6ff, #fff);
    background-size: 100% 37.75rem;
    background-repeat: no-repeat;
  }
  &.subject{
    background: none;
    &.isSpecial{
      background: url('./assets/img/piyao-suject-bg.png') left top no-repeat;
      background-size: 100% auto;
      background-color:#E9E6D1;
      min-height: 100vh;
    }
    &.isNotSpecial{
      background: linear-gradient(360deg, rgba(0, 109, 241, 0) 0%, rgba(0, 109, 241, 0.87) 79%, #006DF1 100%);
      background-size: 100% 37.75rem;
      background-repeat: no-repeat;
        &.channelBg {
          background: linear-gradient(#89e6ff,#89e6ff, #fff);
          background-size: 100% 37.75rem;
          background-repeat: no-repeat;
        }
    }
  }
}

.wap-main {
  width: 100%;
  overflow: hidden;
  &.subject{
    &.isSpecial{
      background:#E9E6D1;
      background-size: 100% auto;
      min-height: 100vh;
    }
  }
  .wap-wrapper {
    width: 100%;
  }
}
</style>
